import React from 'react';
import CustomProvider from 'rsuite/esm/CustomProvider';
import { Particles } from './components/particles';
import { NotificationContainer } from 'react-notifications';
const Landing = React.lazy(() => import('./components/pages/landing'));
const Dashboard = React.lazy(() => import('./components/pages/dashboard'));
const AddonsCatalog = React.lazy(() => import('./components/pages/addons_catalog'));
const Terms = React.lazy(() => import('./components/pages/terms'));
const Privacy = React.lazy(() => import('./components/pages/privacy'));
const StreamkitBalancePrivacy = React.lazy(
    () => import('./components/pages/streamkit_balance_privacy'),
);
const StreamkitBalanceTerms = React.lazy(() => import('./components/pages/streamkit_balance_terms'));
const Help = React.lazy(() => import('./components/pages/help'));
import Admin from './components/pages/admin';
const Connect = React.lazy(() => import('./components/pages/connect'));
const RMkit = React.lazy(() => import('./components/pages/rmkit'));
const RMkitOLD = React.lazy(() => import('./components/pages/rmkit_old'));
const StreamkitBalance = React.lazy(() => import('./components/pages/streamkit_balance'));

import './style/style.less';
import { WebStorage } from './storage';
import { observer } from 'mobx-react';
import { SupportBoardWidget } from './components/support_board';

export const App = observer(() => {
    const { page } = WebStorage;

    React.useEffect(() => {
        console.log('NEW PAGE', page);
    }, [page]);

    React.useEffect(() => {
        if (location.href.startsWith('http://127')) {
            location.replace(location.href.replace('http://', 'https://'));
        }
    }, []);

    return (
        <>
            <CustomProvider theme="dark">
                <Particles />
                {location.search.startsWith('?connect=') ? (
                    <Connect />
                ) : location.search.startsWith('?rmkit=') ? (
                    <RMkit />
                ) : location.search.startsWith('?rmkitold=') ? (
                    <RMkitOLD />
                ) : location.search.startsWith('?streamkit=') ? (
                    <StreamkitBalance />
                ) : (
                    <>
                        <SupportBoardWidget />
                        {page === 'landing' ? <Landing /> : <></>}
                        {page === 'dashboard' ? <Dashboard /> : <></>}
                        {page === 'addons' || page === 'hotkeys' ? <AddonsCatalog /> : <></>}
                        {page === 'privacy' ? <Privacy /> : <></>}
                        {page === 'terms' ? <Terms /> : <></>}
                        {page === 'streamkit-balance-privacy' ? <StreamkitBalancePrivacy /> : <></>}
                        {page === 'streamkit-balance-terms' ? <StreamkitBalanceTerms /> : <></>}
                        {page.startsWith('help') ? <Help /> : <></>}
                        {page === 'admin' ? <Admin /> : <></>}
                    </>
                )}
                <NotificationContainer />
            </CustomProvider>
        </>
    );
});
